<template>
    <div>
        <canvas id="canvas" ref="canvas"></canvas>
    </div>
</template>

<script>
    import Chart from "chart.js";
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    Chart.plugins.unregister(ChartDataLabels);

    export default {
        name: "ChartBar",

        props: {
            'data': {},
            'labels': {},
            'headline': {
                default: 'Headline',
            },
            longtext: {
                default: false,
            },
            colors: {
                default:() => ([
                    '#FF968A',
                    '#CCE2CB',
                ]),
            }
        },


        watch: {
            json() {
                this.chart();
            }
        },


        computed: {
            json() {
                return {
                    type: this.longtext ? 'horizontalBar' : 'bar',
                    plugins: this.data.length <= 10 ? [ChartDataLabels] : [],
                    data: {
                        labels: this.labels,
                        datasets:
                            [{
                                label: this.headline,
                                data: this.data,
                                backgroundColor: '#FF968A',
                            }]
                    },
                    options: {
                        maintainAspectRatio: true,
                        responsive: true,
                        plugins: {
                            datalabels: {
                                color: 'grey',
                                anchor: 'center'
                            }
                        },
                        legend: {
                            display: false,
                            position: 'bottom',
                        },
                        title: {
                            display: false,
                            text: 'Chart.js Bar Chart'
                        },
                        scales: {
                            yAxes: [{
                                display: false,
                                ticks: {
                                  beginAtZero: true,
                                  min: 0
                                }
                            }],
                            xAxes: [{
                                display: true,
                            }],
                        }
                    }
                };
            }
        },

        mounted() {
            this.chart()
        },

        methods: {
            chart() {
                new Chart(this.$refs.canvas, this.json);
            }
        }
    }
</script>

<style scoped>

</style>
